import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Item } from '@app/core/components/listbox/listbox.component';
import { TypeaheadService } from '@app/services/typeahead.service';

@Component({
    selector: 'tt-cuttingplans-change-component',
    templateUrl: './cuttingplans-change-component.component.html',
    styleUrls: ['./cuttingplans-change-component.component.css'],
})
export class CuttingplansChangeComponentComponent {
    public prodId = '';

    public prodName = '';

    constructor(
        private typeahead: TypeaheadService,
        public dialogRef: MatDialogRef<CuttingplansChangeComponentComponent>,
    ) {
        dialogRef.disableClose = true;
        dialogRef.updateSize('min(80rem, 95vw)');
    }

    public onSelected(event?: Item) {
        this.prodId = (event?.item_id ?? '') as string;
        this.prodName = (event?.item_name ?? '') as string;
    }

    public searchProducts = async () => {
        return this.typeahead.lookUpProducts({ prod_name: this.prodName });
    };

    public save() {
        this.dialogRef.close({ prod_id: this.prodId, prod_name: this.prodName });
    }
}
